<template>
  <div class="dropdown" v-bind:class="[position, classes]">
    <div class="trigger" v-on:click.stop="toggleDropdown">
      <slot name="trigger"></slot>
    </div>

    <div v-if="dropdownShown" class="dropdown-menu">
      <div class="dropdown-body" @click.stop="hideDropdown">
        <slot name="dropdown-body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'bottom left',
    },
    classes: {
      type: String,
    },
  },

  data() {
    return {
      dropdownShown: false,
    };
  },

  beforeUnmount() {
    document.body.removeEventListener('click', this.check);
  },

  methods: {
    check(e) {
      if (!this.$el.contains(e.target)) {
        setTimeout(this.hideDropdown);
      }
    },

    toggleDropdown() {
      if (this.dropdownShown) {
        this.hideDropdown();
      } else {
        this.dropdownShown = true;
        document.body.addEventListener('mouseup', this.check);
      }
    },

    hideDropdown() {
      this.dropdownShown = false;
      document.body.removeEventListener('mouseup', this.check);
    },
  },
};
</script>
